export default __webpack_public_path__ + "static/media/atomica.2d904f30.png";